export const /** @type {?} */ FEEDBACK_END_JOURNEY = {
  FIRST_LOAN: 'END_JOURNEY_FIRST_LOAN',
  FIRST_LOAN_DISBURSEMENT: 'END_JOURNEY_FIRST_LOAN_DISBURSEMENT',
  SECOND_LOAN_DISBURSEMENT: 'END_JOURNEY_SECOND_LOAN_DISBURSEMENT',
  PAIDBACK: 'END_JOURNEY_PAIDBACK',
};

export const /** @type {?} */ FEEDBACK_CONTENT = {
  END_JOURNEY_FIRST_LOAN: {
    ces: {
      description: 'Bagaimana proses pengisian formulir di Tunaiku?',
      emotionTextLow: 'Sangat Sulit',
      emotionTextHigh: 'Sangat Mudah',
    },
    emoScore: {
      description:
        'Seberapa puas Anda dengan proses pengisian formulir di Tunaiku?',
      emotionTextLow: 'Tidak Puas',
      emotionTextHigh: 'Sangat Puas',
    },
  },
  END_JOURNEY_FIRSTLOAN_DISBURSEMENT: {
    ces: {
      description: 'Bagaimana pengalaman Anda tanda tangan dengan kurir?',
      emotionTextLow: 'Sangat Sulit',
      emotionTextHigh: 'Sangat Mudah',
    },
    emoScore: {
      description:
        'Seberapa puas Anda dengan proses pencairan dana di Tunaiku?',
      emotionTextLow: 'Tidak Puas',
      emotionTextHigh: 'Sangat Puas',
    },
  },
  END_JOURNEY_SECONDLOAN_DISBURSEMENT: {
    ces: {
      description:
        'Bagaimana pengalaman tanda tangan kontrak online di Tunaiku?',
      emotionTextLow: 'Sangat Sulit',
      emotionTextHigh: 'Sangat Mudah',
    },
    emoScore: {
      description: 'Bagaimana pencairan dana pinjaman kedua di Tunaiku?',
      emotionTextLow: 'Sangat Lama',
      emotionTextHigh: 'Sangat Cepat',
    },
  },
  END_JOURNEY_PAIDBACK: {
    ces: null,
    emoScore: {
      description: 'Bagaimana pengalaman Anda meminjam di Tunaiku?',
      emotionTextLow: 'Sangat Tidak Puas',
      emotionTextHigh: 'Sangat Puas',
    },
  },
};

export const /** @type {?} */ FEEDBACK_JOURNEY_CES_ITEM = [
  {
    name: 'cesPoint',
    src: '/assets/icons/super-frustrated-shape.svg',
    alt: 'Super Frustrated',
    value: 1,
    id: 'BtnCesScoreSuperFrustrated',
  },
  {
    name: 'cesPoint',
    src: '/assets/icons/frustrated-shape.svg',
    alt: 'Frustrated',
    value: 2,
    id: 'BtnCesScoreFrustrated',
  },
  {
    name: 'cesPoint',
    src: '/assets/icons/average-shape.svg',
    alt: 'Average',
    value: 3,
    id: 'BtnCesScoreAverage',
  },
  {
    name: 'cesPoint',
    src: '/assets/icons/happy-shape.svg',
    alt: 'Happy',
    value: 4,
    id: 'BtnCesScoreHappy',
  },
  {
    name: 'cesPoint',
    src: '/assets/icons/super-happy-shape.svg',
    alt: 'Super Happy',
    value: 5,
    id: 'BtnCesScoreSuperHappy',
  },
];

export const /** @type {?} */ FEEDBACK_JOURNEY_EMOSCORE_ITEM = [
  {
    name: 'emoScorePoint',
    src: '/assets/icons/super-frustrated-shape.svg',
    alt: 'Super Frustrated',
    value: 1,
    id: 'BtnEmoScoreSuperFrustrated',
  },
  {
    name: 'emoScorePoint',
    src: '/assets/icons/frustrated-shape.svg',
    alt: 'Frustrated',
    value: 2,
    id: 'BtnEmoScoreFrustrated',
  },
  {
    name: 'emoScorePoint',
    src: '/assets/icons/average-shape.svg',
    alt: 'Average',
    value: 3,
    id: 'BtnEmoScoreAverage',
  },
  {
    name: 'emoScorePoint',
    src: '/assets/icons/happy-shape.svg',
    alt: 'Happy',
    value: 4,
    id: 'BtnEmoScoreHappy',
  },
  {
    name: 'emoScorePoint',
    src: '/assets/icons/super-happy-shape.svg',
    alt: 'Super Happy',
    value: 5,
    id: 'BtnEmoScoreSuperHappy',
  },
];
